export default {
  title: 'Wiki',
  description: 'A collection of user-contributed documentation and guides.',
  // Add more translations as needed
};
